import Browser from '@wetransfer/concorde-browser';

import StaticPage from '@component/panel/content';
import ClickTracker from '@helper/click-tracker';

function addNodes(nodes, list) {
  while (list.firstChild) {
    list.removeChild(list.firstChild);
  }
  Array.prototype.forEach.call(nodes, (product) => {
    list.appendChild(product);
  });
}

StaticPage.configure('/products', (instance) => {
  instance.subscribeToStore = true;
  const trackers = new ClickTracker({
    page: 'products_page',
    body: instance,
    track: [
      {
        selector: '.products-featured__link--plus',
        action: 'click_get_plus',
      },
      {
        selector: '.products-featured__link--mac',
        action: 'click_mac_app',
      },
      {
        selector: '.products-featured__link--paste',
        action: 'click_paste_learn_more',
      },
    ],
  });

  // Featured products are presented in different order depending on device..
  // Desktop order is default order
  if (Browser.isMobile || Browser.isTablet) {
    const wetransferBlock = instance.node.querySelector(
      '#featured-products-wetransfer'
    );
    const collectBlock = instance.node.querySelector(
      '#featured-products-collect'
    );
    const paperBlock = instance.node.querySelector('#featured-products-paper');
    const pasteBlock = instance.node.querySelector('#featured-products-paste');

    const nodes = [wetransferBlock, collectBlock, pasteBlock, paperBlock];

    const list = instance.node.querySelector('.products-featured__list');

    addNodes(nodes, list);

    // On mobile devices, we want to provide mobile links..
    // Add device class to root to activate .hide-for-* classes
    document.documentElement.classList.add(
      `${Browser.isAndroid ? 'android' : 'ios'}-device`
    );
  } else {
    document.documentElement.classList.add('desktop-device');
    trackers.attach();
  }

  instance.onCleanup = () => {
    trackers.remove();
  };
});
